import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/NameLikeness';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class NameLikeness extends Component {
  answers = [
    'Except as required to fulfill the credit obligations set forth above (if any), no Party shall use or' +
      ' employ the names, likeness, marks, logos, or biographical information of any other Party' +
      ' without the prior, written permission of such Party.',

    'The Parties shall be authorized to use or employ the names, likeness, marks, logos, or' +
      ' biographical information (the “Materials”) of any other Party, provided such uses are in' +
      ' connection with the sale, exploitation, license, or promotion of the Work.',
  ];

  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {} };
  }

  options = () => ({
    field1: this.state.changes.field1,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleContent(index) {
    const options = this.options();

    options.field1 = index;
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  renderOriginal() {
    if (this.props.field1 === 0) {
      return `Only when providing a credit. In other cases, collaborators need written permission each time before using the names,
          likeness, trademarks, or biographical information of another collaborator.`;
    } else if (this.props.field1 === 1) {
      return `Collaborators can use the names, likeness, trademarks, or biographical information of
          another collaborator without having to get written permission each time, as long as
          it’s used in a way that relates to the sale, license, or promotion of the work(s).`;
    } else {
      return null;
    }
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="name-likeness"
              checked={changes.field1 === 0}
              readOnly
              onClick={(e) => this.handleContent(0)}
            >
              Only when providing a credit. In other cases, collaborators need
              written permission each time before using the names, likeness,
              trademarks, or biographical information of another collaborator.
            </Radio>
            <Radio
              name="name-likeness"
              checked={changes.field1 === 1}
              readOnly
              onClick={(e) => this.handleContent(1)}
            >
              Collaborators can use the names, likeness, trademarks, or
              biographical information of another collaborator without having to
              get written permission each time, as long as it’s used in a way
              that relates to the sale, license, or promotion of the work(s).
            </Radio>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    if (changeRequest.changes.field1 === 0) {
      return `Only when providing a credit. In other cases, collaborators need written permission each time before using the names,
          likeness, trademarks, or biographical information of another collaborator.`;
    } else if (changeRequest.changes.field1 === 1) {
      return `Collaborators can use the names, likeness, trademarks, or biographical information of
          another collaborator without having to get written permission each time, as long as
          it’s used in a way that relates to the sale, license, or promotion of the work(s).`;
    }

    return `None`;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                How can collaborators use the name and likeness of other
                collaborators?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="name-likeness-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  <div className="pt-7px">{this.renderOriginal()}</div>
                </Radio>
                <hr />
                <Radio
                  name="name-likeness-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  A collaborator's name and likeness can include their name,
                  monikers, images, and trademarks that represent themselves.
                  Taking the time now to state when collaborators need to get
                  permission from each other to use these things can help you to
                  complete deals efficiently and to avoid issues of
                  misrepresentation in the future.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/NameLikeness.jsx